/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_3_AnswerInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_3_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A data-only import may be enough if you deliberately want a snapshot. Before using it, check whether formula results were recalculated and saved in the source app. Label the imported file as a snapshot, because a displayed total that came from a saved result will not behave like a live formula.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_3_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果明确只需要数据快照，仅导入数值可能已经足够。但使用前应确认来源应用已经重新计算并保存了公式结果。把导入文件标注为快照，因为从已保存结果导入的合计，不会像实时公式那样继续计算。`)
};

/**
* | output |
* | --- |
* | "A data-only import may be enough if you deliberately want a snapshot. Before using it, check whether formula results were recalculated and saved in the sourc..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_3_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_3_answer = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_3_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_3_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_3_answer(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_3_answer(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_3_answer as "gc.search_guides.gridcraft_excel_compatibility.sections.8.questions.3.answer" }